<template>
    <div>
        <el-row>
            <el-col :span="24">
                <Head>
                    <template v-slot:title>
                        <span style="margin-left:30%;"></span>
                    </template>
                </Head>
            </el-col>
        </el-row>
        <el-row class="row-top" type="flex" justify="center">
            <el-col :span="15">
                <baseList v-if="isShow" @statusFun="getStatus" :type="type"></baseList>
                <baseXq v-else @statusFun="getStatus" :item="itemData"></baseXq>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import Head from '@/components/header/head.vue';
import baseList from '@/components/audit/audit_list.vue';
import baseXq from '@/views/audit/base/base_particulars.vue';
export default {
    data(){
        return {
            type:'3',
            itemData:[],

            isShow:true,

        }
    },
    methods:{
       getStatus(isShow,itemData){
        
           this.isShow = isShow
           if(itemData){
               this.itemData = itemData
           }
       }
    },
    components:{
        Head,
        baseList,
        baseXq
        
    }
}
</script>
<style lang="less" scoped>
        
</style>